import React from 'react';
import { FiCheck, FiArrowRight } from 'react-icons/fi';
import './Pricing.css';

const PricingCard = ({ title, price, mau, description, features, isPopular, buttonText, index }) => {
  return (
    <div 
      className={`pricing-card ${isPopular ? 'popular' : ''}`}
      data-aos="fade-up"
      data-aos-delay={index * 100}
    >
      {isPopular && (
        <div className="popular-badge">Most Popular</div>
      )}
      <div className="pricing-header">
        <h3 className="pricing-title">{title}</h3>
        <div className="pricing-price">{price}</div>
        <div className="pricing-mau">{mau}</div>
        <p className="pricing-description">{description}</p>
      </div>
      
      <ul className="pricing-features">
        {features.map((feature, idx) => (
          <li key={idx} className="pricing-feature">
            <FiCheck className="feature-icon" />
            <span>{feature}</span>
          </li>
        ))}
      </ul>
      
      <a href="#contact" className={`pricing-button ${isPopular ? 'popular-button' : ''}`}>
        {buttonText} {isPopular && <FiArrowRight className="btn-icon" />}
      </a>
      
      <div className="pricing-card-glow"></div>
    </div>
  );
};

const Pricing = () => {
  const plans = [
    {
      title: "Starter",
      price: "$499 / month",
      mau: "Up to 20K monthly active users",
      description: "Perfect for startups and small apps",
      features: [
        "Image Stories",
        "Video Stories",
        "Up to 10 active stories",
        "Links and buttons in stories",
        "Analytics"
      ],
      buttonText: "Get Started"
    },
    {
      title: "Professional",
      price: "$599 / month",
      mau: "Up to 30K monthly active users",
      description: "Perfect for companies and large apps",
      features: [
        "Image Stories",
        "Video Stories",
        "Up to 25 active stories",
        "Links, buttons and polls in stories",
        "Scheduled Publish",
        "Advanced analytics",
        "Priority support"
      ],
      isPopular: true,
      buttonText: "Get Started"
    },
    {
      title: "Enterprise",
      price: "Custom",
      mau: "High volume of monthly active users",
      description: "For large-scale applications",
      features: [
        "Image Stories",
        "Video Stories",
        "Unlimited active stories",
        "Links, buttons and polls in stories",
        "Scheduled Publish",
        "Enterprise analytics",
        "Priority support"
        ],
      buttonText: "Contact Us"
    }
  ];

  return (
    <section id="pricing" className="pricing">
      <div className="pricing-container">
        <div className="pricing-header">
          <h2 className="section-title" data-aos="fade-up">
            Simple, <span className="gradient-text">Transparent</span> Pricing
          </h2>
          <p className="section-description" data-aos="fade-up" data-aos-delay="100">
            Choose the plan that's right for your app's growth
          </p>
        </div>

        <div className="pricing-grid">
          {plans.map((plan, index) => (
            <PricingCard
              key={index}
              title={plan.title}
              price={plan.price}
              mau={plan.mau}
              description={plan.description}
              features={plan.features}
              isPopular={plan.isPopular}
              buttonText={plan.buttonText}
              index={index}
            />
          ))}
        </div>
      </div>
      
      <div className="pricing-shapes">
        <div className="pricing-shape pricing-shape-1"></div>
        <div className="pricing-shape pricing-shape-2"></div>
      </div>
    </section>
  );
};

export default Pricing;